export default __webpack_public_path__ + "static/media/balloon.90f86df0.svg";